import { get } from "core-web/libs/GrebbCommerceAPI/util";
import { getModel } from "core-web/state";

export default async (email: string) => {
    const applicationId: number = getModel("application").applicationId;

    return await get("/frontend/user/promotions", {
        application_id: applicationId,
        email,
    });
};
